let graphqlHost = process.env.REACT_APP_GRAPHQL_HOST;
let clockworkwebHost = process.env.REACT_APP_CLOCKWORK_WEB_HOST;
let staticAssetHost = process.env.REACT_APP_CLOCKWORK_STATIC_ASSET_HOST;
const isPureLocal = process.env.REACT_APP_MSW_ENABLED === "true";
const isProduction = window.location
  .toString()
  .includes("prod.vibe.justworks.com");

function getHostFromPageHost(): string {
  const { port, protocol, hostname } = window.location;
  const portToUse = port ? `:${port}` : "";
  const hostSubdomains = hostname.split(".");
  if (hostSubdomains[0].includes("-fe")) {
    hostSubdomains[0] = hostSubdomains[0].replace("-fe", "");
  }
  return `${protocol}//${hostSubdomains.join(".")}${portToUse}`;
}

function buildPath(base: string, path: string): string {
  const normalizeSlashPath = path.replace("//", "/");
  const cleanPath = normalizeSlashPath.startsWith("/")
    ? normalizeSlashPath
    : `/${normalizeSlashPath}`;
  return `${base}${cleanPath}`;
}

function buildGraphQLPath(path: string): string {
  if (!graphqlHost || isPureLocal) {
    graphqlHost = getHostFromPageHost();
  }
  return buildPath(graphqlHost, path);
}

function buildWebPath(path: string): string {
  return path.includes("/cf/") ? path : buildClockworkWebPath(path);
}

function buildClockworkWebPath(path: string): string {
  if (!clockworkwebHost || isPureLocal) {
    clockworkwebHost = getHostFromPageHost();
  }
  return buildPath(clockworkwebHost, path);
}

function buildStaticAssetPath(path: string): string {
  if (!staticAssetHost || isPureLocal) {
    const { port, protocol, hostname } = window.location;
    const portToUse = port ? `:${port}` : "";
    staticAssetHost = `${protocol}//${hostname}${portToUse}`;
  }

  return buildPath(staticAssetHost, `/${path}`);
}

function buildCsToolsPath(): string {
  if (isProduction) {
    return "cstools.justworks.com/internal";
  } else {
    return buildWebPath("/internal");
  }
}

export {
  buildWebPath,
  buildCsToolsPath,
  buildGraphQLPath,
  buildStaticAssetPath,
};
